import React, { useState, useRef } from 'react';
import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
import axios from 'axios';
import { Alert } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha'

function Contact() {
  const [nom, setNom] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const [isLoading, setIsLoading] = useState(false); 
  const [error, setError] = useState(); 
  const [success, setSuccess] = useState(); 
  const [showModal, setShowModal] = useState(false)
  const recaptcha = useRef()
  const apiUrl = process.env.REACT_APP_API_URL;
  
  



  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); 

    const captchaValue = recaptcha.current.getValue()

    if (!email || !nom || !message) {
      setError("Veuillez remplir tous les champs du formulaire.");
      setIsLoading(false);
      return;
    }
    else if (!captchaValue) {
      setError("Veuillez vérifier le captcha");
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${apiUrl}/contact/ajouter`, {
        nom : nom,
        email: email,
        message : message,
        captcha: captchaValue        
      });

      setError(null);
      setIsLoading(false);
      setSuccess(response.data.message)
      setEmail('')
      setMessage('')
      setNom('')




    } catch (error) {
      setIsLoading(false);
      if (error.response) {
        
        setError(error.response.data.message);
      } else {
        
        setError(true)
      }
    }

  };


  if (isLoading) {
    return (
    <div className="centered-content">
      <img src="/img/logo.png" alt="Logo" className="centered-logo" />
      <br/>
      <span className="loader"></span>
    </div>
    
    ); 
  }

  return (
      <Row style={{margin:'5%'}}>
            <Modal show={showModal} onHide={() => {setShowModal(false);}}>
              <Modal.Header closeButton>
                <Modal.Title>Confirmation de l'envoie de votre message</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Votre message est prêt à être envoyé. Veuillez confirmer que vous souhaitez l'envoyer maintenant. Si vous avez besoin de faire des modifications, vous pouvez fermer cette fenêtre et ajuster votre message avant de le soumettre.
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => {setShowModal(false); }}>Fermer</Button>
                <Button variant="primary" onClick={(e) => {setShowModal(false); handleSubmit(e)}} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>Confirmer</Button>
              </Modal.Footer>
            </Modal>
        {error && 
            <Alert key="danger" variant="danger">
            {error}
          </Alert>
          }
        {success && 
            <Alert key="success" variant="success">
            {success}
          </Alert>
          }
        <Col md={6}>
          <h2>Contactez-nous</h2>
          <p>N'hésitez pas à nous contacter pour toute question ou demande d'information.</p>
          <Form >
            <Form.Group controlId="formName">
              <Form.Label>Votre nom</Form.Label>
              <Form.Control type="text" name="name" value={nom} onChange={(e)=> setNom(e.target.value)} placeholder="Entrez votre nom" required />
            </Form.Group>
            <Form.Group controlId="formEmail">
              <Form.Label>Votre adresse e-mail</Form.Label>
              <Form.Control type="email" name="email" value={email} onChange={(e)=> setEmail(e.target.value)} placeholder="Entrez votre adresse e-mail" required />
            </Form.Group>
            <Form.Group controlId="formMessage">
              <Form.Label>Votre message</Form.Label>
              <Form.Control as="textarea" name="message" value={message} onChange={(e)=> setMessage(e.target.value)} rows={4} placeholder="Entrez votre message" required />
            </Form.Group>
            <br/>
            <ReCAPTCHA ref={recaptcha} sitekey={process.env.REACT_APP_KEY_CAPTCHA} />
            <br/>
            <Button onClick={()=> setShowModal(true)} variant="primary" disabled={success}  style={{backgroundColor:"#00E676", borderColor:'#00E676'}} >
              Envoyer
            </Button>
          </Form>
          <br/>
        </Col>
        <Col md={6}>
          <h2>Coordonnées</h2>
          <p> Nom : Lassois </p>
          <p>Prénom : Patrick</p>
          <p>E-mail : patrick.lassois@live.be</p>
          <img src="/img/logo.png" alt="Logo de votre entreprise" style={{ maxWidth: '30%', height: 'auto' }} />
        </Col>
      </Row>
  );
}

export default Contact;
